
// get relevat elements
const uiRootContainer = document.querySelector('.wp-block-hs-blocks-ui-root-container') || false;
const uiMainComponentsLayer = document.querySelector('.wp-block-hs-blocks-ui-main-components-layer') || false;
const wpAdminBar = document.querySelector('#wpadminbar') || false;


// adjust content if wpAdminBar is present
if (wpAdminBar) {
    hs_core.addTask(() => {

        const wpAdminBarHeight = wpAdminBar.getBoundingClientRect().height;

        if (uiMainComponentsLayer) {
            uiMainComponentsLayer.style.top = `${wpAdminBarHeight}px`;
        }

        if (uiRootContainer) {
            uiRootContainer.style.top = `${wpAdminBarHeight}px`;
        }

    })
}

// bin keyboard inputs
//initNavKeyMappings();
window.addEventListener('keyup', (e) => {
    if (e.code === 'Escape') {
        uiRootContainer.classList.toggle('ui-nav-active');
    }

})

// adjust theme color 

if (uiRootContainer.dataset.themeColor) {
    document.body.style.backgroundColor = uiRootContainer.dataset.themeColor;
}

const initNavKeyMappings = () => {
    window.addEventListener('keyup', (e) => {
        if (e.code === 'Escape') {
            uiRootContainer.classList.remove('ui-nav-active', 'ui-modal-active');
        }
        if (e.code === 'KeyM') {
            uiRootContainer.classList.remove('ui-nav-active');
            uiRootContainer.classList.toggle('ui-modal-active');
        }
        if (e.code === 'KeyN') {
            uiRootContainer.classList.remove('ui-modal-active');
            uiRootContainer.classList.toggle('ui-nav-active');
        }

    })
}
